var map = {
	"./App": "M93x",
	"./App.vue": "M93x",
	"./assets/carrier/bpost.png": "9k10",
	"./assets/carrier/dpd.png": "f+ty",
	"./assets/css/slider.css": "1Rxe",
	"./assets/discount.png": "bubI",
	"./assets/logo.png": "7Otq",
	"./assets/logo_small.png": "lhcC",
	"./assets/payment/bancontact.png": "8SGZ",
	"./assets/payment/ideal.png": "lEmZ",
	"./assets/scss/custom-bootstrap.scss": "RMf/",
	"./components/CartButton": "wrYO",
	"./components/CartButton.vue": "wrYO",
	"./components/ClickConfirm": "6K11",
	"./components/ClickConfirm.vue": "6K11",
	"./components/LocaleSwitcher": "f6gp",
	"./components/LocaleSwitcher.vue": "f6gp",
	"./components/LocationPicker": "SHIo",
	"./components/LocationPicker.vue": "SHIo",
	"./components/Navigation": "bwGm",
	"./components/Navigation.vue": "bwGm",
	"./components/Notification": "tqlH",
	"./components/Notification.vue": "tqlH",
	"./components/NotificationButton": "oTdU",
	"./components/NotificationButton.vue": "oTdU",
	"./components/product/ProductFilter": "5Wxr",
	"./components/product/ProductFilter.vue": "5Wxr",
	"./components/product/ProductInfo": "4JZW",
	"./components/product/ProductInfo.vue": "4JZW",
	"./components/product/ProductTile": "kk4A",
	"./components/product/ProductTile.vue": "kk4A",
	"./components/project/Approval": "+RFq",
	"./components/project/Approval.vue": "+RFq",
	"./components/project/Countdown": "H6ur",
	"./components/project/Countdown.vue": "H6ur",
	"./components/project/ProjectInfo": "grEV",
	"./components/project/ProjectInfo.vue": "grEV",
	"./components/project/ProjectTile": "NYod",
	"./components/project/ProjectTile.vue": "NYod",
	"./components/project/TreeView": "zuha",
	"./components/project/TreeView.vue": "zuha",
	"./components/project/Update": "4hRv",
	"./components/project/Update.vue": "4hRv",
	"./i18n": "mWYR",
	"./i18n/": "mWYR",
	"./i18n/about/en.html": "2bKB",
	"./i18n/about/nl.html": "QlBS",
	"./i18n/create/en.html": "+rbt",
	"./i18n/create/nl.html": "e6Mg",
	"./i18n/disclaimer/en.html": "CnUm",
	"./i18n/disclaimer/nl.html": "O8ng",
	"./i18n/index": "mWYR",
	"./i18n/index.js": "mWYR",
	"./i18n/locale/en": "hTru",
	"./i18n/locale/en.json": "hTru",
	"./i18n/locale/nl": "h6si",
	"./i18n/locale/nl.json": "h6si",
	"./i18n/privacy/en.html": "Jn/p",
	"./i18n/privacy/nl.html": "SRGF",
	"./i18n/return/en.html": "RlpZ",
	"./i18n/return/nl.html": "CNdb",
	"./i18n/shipping/en_post.html": "LmI/",
	"./i18n/shipping/en_pre.html": "4LUd",
	"./i18n/shipping/nl_post.html": "Jc5o",
	"./i18n/shipping/nl_pre.html": "8jYM",
	"./i18n/terms/en.html": "B8AA",
	"./i18n/terms/nl.html": "RKSy",
	"./lib/validators": "mh2Y",
	"./lib/validators.js": "mh2Y",
	"./main": "NHnr",
	"./main.js": "NHnr",
	"./mixin": "is1l",
	"./mixin/": "is1l",
	"./mixin/default": "2mzY",
	"./mixin/default.js": "2mzY",
	"./mixin/index": "is1l",
	"./mixin/index.js": "is1l",
	"./mixin/navigation": "nnYj",
	"./mixin/navigation.js": "nnYj",
	"./mixin/notification": "78so",
	"./mixin/notification.js": "78so",
	"./mixin/product": "5rnv",
	"./mixin/product.js": "5rnv",
	"./mixin/project": "LXA/",
	"./mixin/project-item": "iD9o",
	"./mixin/project-item.js": "iD9o",
	"./mixin/project.js": "LXA/",
	"./pages/About": "en7K",
	"./pages/About.vue": "en7K",
	"./pages/Contact": "uRks",
	"./pages/Contact.vue": "uRks",
	"./pages/DisclaimerCreate": "4KJ+",
	"./pages/DisclaimerCreate.vue": "4KJ+",
	"./pages/DisclaimerParticipate": "chKL",
	"./pages/DisclaimerParticipate.vue": "chKL",
	"./pages/Donate": "Cjzz",
	"./pages/Donate.vue": "Cjzz",
	"./pages/LandingDashboard": "vfE2",
	"./pages/LandingDashboard.vue": "vfE2",
	"./pages/Login": "P7ry",
	"./pages/Login.vue": "P7ry",
	"./pages/Messages": "9dOY",
	"./pages/Messages.vue": "9dOY",
	"./pages/PageNotFound": "5CYW",
	"./pages/PageNotFound.vue": "5CYW",
	"./pages/Privacy": "fe4i",
	"./pages/Privacy.vue": "fe4i",
	"./pages/Profile": "qKQV",
	"./pages/Profile.vue": "qKQV",
	"./pages/Register": "S2NW",
	"./pages/Register.vue": "S2NW",
	"./pages/RequestPassword": "D/Rs",
	"./pages/RequestPassword.vue": "D/Rs",
	"./pages/ResetPassword": "gZcy",
	"./pages/ResetPassword.vue": "gZcy",
	"./pages/Return": "/C95",
	"./pages/Return.vue": "/C95",
	"./pages/Shipping": "HPdc",
	"./pages/Shipping.vue": "HPdc",
	"./pages/Sint": "ZD8r",
	"./pages/Sint.vue": "ZD8r",
	"./pages/Terms": "KM5k",
	"./pages/Terms.vue": "KM5k",
	"./pages/User": "35em",
	"./pages/User.vue": "35em",
	"./pages/product/Cart": "NURs",
	"./pages/product/Cart.vue": "NURs",
	"./pages/product/CreateProduct": "Q5NO",
	"./pages/product/CreateProduct.vue": "Q5NO",
	"./pages/product/Delivery": "butQ",
	"./pages/product/Delivery.vue": "butQ",
	"./pages/product/Order": "RCIG",
	"./pages/product/Order.vue": "RCIG",
	"./pages/product/Orders": "f6jC",
	"./pages/product/Orders.vue": "f6jC",
	"./pages/product/Product": "XYLu",
	"./pages/product/Product.vue": "XYLu",
	"./pages/product/ProductDashboard": "cNjr",
	"./pages/product/ProductDashboard.vue": "cNjr",
	"./pages/product/Products": "Hu3/",
	"./pages/product/Products.vue": "Hu3/",
	"./pages/project/CreateProject": "T/hj",
	"./pages/project/CreateProject.vue": "T/hj",
	"./pages/project/Project": "GxNj",
	"./pages/project/Project.vue": "GxNj",
	"./pages/project/ProjectDashboard": "OUcI",
	"./pages/project/ProjectDashboard.vue": "OUcI",
	"./pages/project/Projects": "6ZIj",
	"./pages/project/Projects.vue": "6ZIj",
	"./router": "YaEn",
	"./router/": "YaEn",
	"./router/index": "YaEn",
	"./router/index.js": "YaEn",
	"./services": "+vOg",
	"./services/": "+vOg",
	"./services/bgg.service": "lIDR",
	"./services/bgg.service.js": "lIDR",
	"./services/currency.service": "ZfSQ",
	"./services/currency.service.js": "ZfSQ",
	"./services/days.service": "98bB",
	"./services/days.service.js": "98bB",
	"./services/email.service": "dKBM",
	"./services/email.service.js": "dKBM",
	"./services/gamefound.service": "fC5n",
	"./services/gamefound.service.js": "fC5n",
	"./services/geocode.service": "Gzld",
	"./services/geocode.service.js": "Gzld",
	"./services/index": "+vOg",
	"./services/index.js": "+vOg",
	"./services/kickstarter.service": "ygF3",
	"./services/kickstarter.service.js": "ygF3",
	"./services/message.service": "RV1y",
	"./services/message.service.js": "RV1y",
	"./services/order.service": "/Qrn",
	"./services/order.service.js": "/Qrn",
	"./services/product.service": "XYMA",
	"./services/product.service.js": "XYMA",
	"./services/project.service": "oZit",
	"./services/project.service.js": "oZit",
	"./services/token.service": "ysq/",
	"./services/token.service.js": "ysq/",
	"./services/user.service": "4MTg",
	"./services/user.service.js": "4MTg",
	"./vuex": "l+I4",
	"./vuex/": "l+I4",
	"./vuex/index": "l+I4",
	"./vuex/index.js": "l+I4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+gN6";


//////////////////
// WEBPACK FOOTER
// ./src ^\.\/.*$
// module id = +gN6
// module chunks = 1